<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="ma-0">
        <v-card elevation="6">
          <v-slide-x-reverse-transition>
            <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
          </v-slide-x-reverse-transition>
          <div class="pa-4">
            <div class="text-right ma-2">
              <v-btn x-large class="text-center grad-success-bg white--text btn_size" to="/stock/quotation/quotationcreate">
                สร้างใบเสนอราคา
              </v-btn>
            </div>
            <div class="pa-2">
              <v-divider/>
              <div v-if="loading_data === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                  <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
              </div>
              <div v-else>
                <v-data-table :headers="headers" :items="data_list" :footer-props="footer_Props" mobile-breakpoint="0">
                  <template slot="item" slot-scope="dataDetail">
                    <tr>
                      <td>{{ dataDetail.item.quotation_code }}</td>
                      <td>
                        <div v-if="dataDetail.item.date !== null && dataDetail.item.date !== ''">{{ diff_dateTH(dataDetail.item.date) }}</div>
                        <div v-else>{{ dataDetail.item.date }}</div>
                      </td>
                      <td>{{ dataDetail.item.customer_name }}</td>
                      <td>{{ format_number(dataDetail.item.total) }}</td>
<!--                      <td>-->
<!--                        <v-btn v-if="dataDetail.item.status === 0" small height="42" style="font-size: 16px" @click="sellProduct(dataDetail.item.id)" class="grad-warning-bg white&#45;&#45;text mr-1 mb-1" title="แก้ไข">-->
<!--                          กำลังดำเนินการ-->
<!--                        </v-btn>-->
<!--                        <div v-else-if="dataDetail.item.status === 1" style="color: #8cc63e">ขายแล้ว</div>-->
<!--                      </td>-->
                      <td v-if="tab_list === 1">{{ dataDetail.item.user_name }}</td>
                      <td class="pa-3">
                        <div v-if="tab_list === 1">
                          <v-btn small height="42" @click="getDetails(dataDetail.item.id)" class="grad-success-bg white--text mr-1 mb-1" title="รายละเอียด">
                            <v-icon>mdi-magnify</v-icon>
                          </v-btn>
                          <v-btn small height="42" @click="getEdit(dataDetail.item.id)" class="grad-warning-bg white--text mr-1 mb-1" title="แก้ไข">
                            <v-icon>mdi-note-edit-outline</v-icon>
                          </v-btn>
                          <v-btn small height="42" @click="delAlert(dataDetail.item.id)" class="grad-danger-bg white--text mb-1" title="ลบ">
                            <v-icon>mdi-delete-empty-outline</v-icon>
                          </v-btn>
                          <v-btn small height="42" @click="getPrinter(dataDetail.item.id)" class="grad-main-bg white--text ml-1 mb-1" title="พิมพ์ใบเสร็จ">
                            <v-icon>mdi-printer</v-icon>พิมพ์
                          </v-btn>
                        </div>
                        <div v-if="tab_list === 2">
                          <v-btn small height="42" @click="getDetailsShop(dataDetail.item.id)" class="grad-success-bg white--text mr-1 mb-1" title="ดูรายละเอียด">
                            <v-icon>mdi-magnify</v-icon>
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
import {diffDateTH, formatNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Quotation_main",
  data() {
    return {
      loading_page: false,
      loading_data: false,
      alert_success: false,
      tab_list: 1,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'เลขที่',
          value: 'quotation_code',
          fixed: true,
          width: '140px',
        },
        {
          text: 'วันที่',
          value: 'date',
          fixed: true,
          width: '130px',
        },
        {
          text: 'ลูกค้า',
          value: 'customer_name',
          fixed: true,
          width: '250px',
        },
        {
          text: 'ยอด',
          value: 'total',
          fixed: true,
          width: '150px',
        },
        // {
        //   text: 'สถานะ',
        //   value: 'status',
        //   sortable: false,
        //   fixed: true,
        //   width: '180px',
        // },
        {
          text: 'ผู้จัดทำ',
          value: 'user_name',
          fixed: true,
          width: '130px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '350px',
        },
      ],
      data_list: [],
    }
  },
  methods: {
    async page(type) {
      this.tab_list = type
      if (type === 1) {
        this.headers = [
          {
            text: 'เลขที่',
            value: 'quotation_code',
            fixed: true,
            width: '140px',
          },
          {
            text: 'วันที่',
            value: 'date',
            fixed: true,
            width: '130px',
          },
          {
            text: 'ลูกค้า',
            value: 'customer_name',
            fixed: true,
            width: '250px',
          },
          {
            text: 'ยอด',
            value: 'total',
            fixed: true,
            width: '150px',
          },
          // {
          //   text: 'สถานะ',
          //   value: 'status',
          //   sortable: false,
          //   fixed: true,
          //   width: '180px',
          // },
          {
            text: 'ผู้จัดทำ',
            value: 'user_name',
            fixed: true,
            width: '130px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '350px',
          },
        ]
      }
      if (type === 2) {
        this.headers = [
          {
            text: 'เลขที่',
            value: 'quotation_code',
            fixed: true,
            width: '140px',
          },
          {
            text: 'วันที่',
            value: 'date',
            fixed: true,
            width: '130px',
          },
          {
            text: 'ลูกค้า',
            value: 'customer_name',
            fixed: true,
            width: '250px',
          },
          {
            text: 'ยอด',
            value: 'total',
            fixed: true,
            width: '150px',
          },
          // {
          //   text: 'สถานะ',
          //   value: 'status',
          //   fixed: true,
          //   width: '180px',
          // },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '300px',
          },
        ]
      }
      await this.get_quotation()
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    get_quotation() {
      this.loading_data = true
      HTTP.post('/quotations/quotationall', {
        quo_type: 1
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_data = false
          this.data_list = res.data.object
        }
      })
    },
    diff_dateTH: function (value) {
      return diffDateTH(value)
    },
    getDetails(id) {
      this.$router.push('/stock/quotation/quotationdetail/' + id)
    },
    getEdit(id) {
      this.$router.push('/stock/quotation/quotationedit/' + id)
    },
    delAlert(id) {
      Swal.fire({
        title: 'คุณต้องลบข้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.getDelete(id)
        }
      });
    },
    sellProduct() {
      Swal.fire({
        title: 'คุณต้องการดำเนินการต่อหรือไม่ ?',
        text: 'หากดำเนินการต่อสินค้าจะถูกเปลี่ยนสถานะเป็น ขายแล้ว',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          this.alert_success = true
          setTimeout(() => this.alert_success = false, 2000)
          this.get_quotation()
        }
      })
    },
    getDelete(id) {
      HTTP.post('/quotations/delete', {
        quotation_id: id
      }).then((res) => {
        if (res.data.success === true) {
          Swal.fire('ลบข้อมูลเรียบร้อย', '', 'success');
          this.get_quotation();
        }
      });
    },
    getPrinter(id) {
      window.open('https://www.pharmacare-plus.com/quotationpdf?id=' + id, '_blank')
    },
    getDetailsShop(id) {
      this.$router.push('/stock/quotation/quotationdetailshop/' + id)
    },
    // sellProduct(id) {
    //   Swal.fire({
    //     title: 'คุณต้องการยืนยันการขาย ?',
    //     icon: 'warning',
    //     showDenyButton: true,
    //     showCancelButton: false,
    //     confirmButtonText: `ตกลง`,
    //     denyButtonText: `ยกเลิก`,
    //   }).then((res) => {
    //
    //   })
    // }
  },
  mounted() {
    this.page(1)
  }
}
</script>

<style scoped>
.btn_size {
  font-size: 16px;
  width: 25%;
}
@media only screen and (max-width: 1180px) {
  .btn_size {
    font-size: 16px;
    width: 40%;
  }
}
@media only screen and (max-width: 500px) {
  .btn_size {
    font-size: 16px;
    width: 100%;
  }
}
</style>
